export default __webpack_public_path__ + "static/brush-3910f7ae85347044c90a1c39906dbcca.png";